const _map = new Map([['pjaxComplete', new Set()], ['ready', new Set()] /* , ['load', new Set()] */]);
function _getListenerList(eventName) {
    const listener_list = _map.get(eventName);
    if (listener_list) {
        return listener_list;
    }
    else {
        throw new TypeError('[Sakurairo] unknown name.');
    }
}
export function dispatch(eventName) {
    const list = _getListenerList(eventName);
    return Promise.all(Array.from(list.values()).map(cb => cb()));
}
export const on = (eventName, cb) => {
    _getListenerList(eventName).add(cb);
};
/**
 *
 * @param key 这段句子的中文表述（默认语言）
 */
//@ts-ignore
export const __ = (defaultStr) => (window._sakurairoi18n && _sakurairoi18n[defaultStr]) || defaultStr;
/**
 *
 * 占位符格式 {index} ex.{0}
 * @param defaultStr 这段句子的中文表述（默认语言）
 * @param replacements 句子中占位符的替代元素
 */
export const _$ = (defaultStr, ...replacements) => {
    let template = __(defaultStr);
    for (const index in replacements) {
        template = template.replace('{' + index + '}', replacements[index]);
    }
    return template;
};
export const sakurairoGlobal = {
    opt: {},
    on,
    __
    /*     _sys_call:sys_call
     */ 
};
if ('_sakurairo' in window) {
    //@ts-ignore
    const _sakurairo = window._sakurairo;
    if ('opt' in _sakurairo) {
        sakurairoGlobal.opt = _sakurairo.opt;
    }
}
//@ts-ignore
window._sakurairo = sakurairoGlobal;
